<template>
  <v-row>
    <v-col cols="12">
      <v-card color="grey lighten-5">
        <v-card-text class="pa-2">
          <v-row dense no-gutters>
            <div :style="{color: $randomizeColorFromString(team.key)}" class="body-1 font-weight-bold my-1">
              {{ team.name }}
            </div>
            <v-spacer></v-spacer>
            <v-btn :disabled="!teamMembers || teamMembersLength === 0"
                   :icon="$vuetify.breakpoint.xsOnly"
                   color="secondary" outlined
                   small
                   @click="toggleTeamMemberList">
              <v-badge :content="teamMembersLength" :inline="$vuetify.breakpoint.smAndUp"
                       :overlap="$vuetify.breakpoint.xsOnly" :value="teamMembersLength || false" color="accent"
                       light
                       small
              ><span v-if="$vuetify.breakpoint.smAndUp">{{ $t(toggleButtonText) }}</span>
                <v-icon v-else dense>mdi mdi-account-multiple</v-icon>
              </v-badge>
            </v-btn>
          </v-row>
        </v-card-text>
        <v-list v-if="showMembersList && !!teamMembers && teamMembersLength > 0" color="transparent" dense>
          <v-virtual-scroll
            :height="scrollHeightComputed"
            :items="teamMembers"
            item-height="40">
            <template v-slot:default="{ item }">
              <v-list-item :key="item.id" class="px-2">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item.email }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SurveyTeamItem",
  props: ['team'],
  data() {
    return {
      showMembersList: false,
      maxShownMembers: 10,
    }
  },
  computed: {
    teamMembers() {
      if (this.team.answerers.length === 0) return;
      return this.team.answerers.map((a) => {
        return {id: a.id, email: a.email}
      })
    },
    teamMembersLength() {
      return this.team.answerers.map((a) => {
        return a.id
      })?.length;
    },
    scrollHeightComputed() {
      if (this.teamMembersLength < 2) {
        return (this.teamMembersLength * 40)
      } else if (this.teamMembersLength < 6) {
        return (this.teamMembersLength * 40) - 20
      } else {
        return 175
      }
    },
    toggleButtonText: function () {
      if (this.teamMembersLength === 0) {
        return 'team.no_team_members_button'
      }
      if (this.showMembersList) {
        return 'team.hide_team_members'
      } else {
        return 'team.show_team_members'
      }
    }
  },
  methods: {
    toggleTeamMemberList() {
      this.showMembersList = !this.showMembersList;
    },
  }
}
</script>

<style scoped>

</style>
